export const DAILY_POINTERS = [
  "What is here when there is no thought?",
  "Close your eyes and ask: Where is the 'I'?",
  "Thought is only a reflection in the mirror of consciousness",
  "You are not your body, you are not your mind - then what are you?",
  "The seeker is what is being sought",
  "In this moment, what is missing?",
  "Who is it that experiences?",
  "The mirror cannot see itself - it can only reflect",
];

export const JOURNEY_PATHS = [
  {
    id: 1,
    title: "Who is the Thinker?",
    description: "A guided inquiry into the nature of thought",
    duration: "15 min",
    theme: "thought"
  },
  {
    id: 2,
    title: "The Dream of Reality",
    description: "Exploring the waking dream",
    duration: "20 min",
    theme: "dream"
  },
  {
    id: 3,
    title: "Quantum Plexus",
    description: "Pointing to the subtle energy of being",
    duration: "25 min",
    theme: "energy"
  }
];

export const LIBRARY_FRAGMENTS = [
  {
    id: 1,
    text: "You are eternal! Get this straight, there is no such thing as 'Death'.",
    theme: "eternity"
  },
  {
    id: 2,
    text: "Thinking will not lead to the natural state or enlightenment. It will put you on a train track created by your conditioned impression.",
    theme: "thought"
  },
  {
    id: 3, 
    text: "The whole existence wants you to witness it and in this witnessing you feel good.",
    theme: "witnessing"
  },
  {
    id: 4,
    text: "Freedom is your true nature. The meaning of freedom is freeing you from illusions.",
    theme: "freedom"
  }
];